import templateUrl from './listview-table.tpl.html';

angular
    .module('festzelt-os.components')
    .component('listviewTable', {
        bindings: {
            store: '=',
        },
        controller() {
            this.lodash = _;
            this.$onInit = () => {
            }
        },
        controllerAs: 'vm',
        templateUrl: templateUrl
    });



// WEBPACK FOOTER //
// ./src/app/components/state-manager/listview/table/listview-table.js